import { useEffect, useRef, useState } from 'react';
import GuideStepOne from '@/assets/images/guide/guide-step-1.png';
import GuideStepTwo from '@/assets/images/guide/guide-step-2.png';
import GuideStepThree from '@/assets/images/guide/guide-step-3.png';
import CloseIcon from '@/assets/images/icons/close.svg';
import ActiveCircleIcon from '@/assets/images/icons/active-rectangle.svg';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';

type Props = {
	open: boolean;
	onOpenChange: (open: boolean) => void;
	onCancel?: () => void;
};

export function SwipeAlertDialog({ open, onOpenChange, onCancel }: Props) {
	const [activeIndex, setActiveIndex] = useState(0);
	const swiperRef = useRef<any>(null);

	const GuideSteps = [
		{ img: GuideStepOne, label: 'Step 1', description: 'Tap Settings' },
		{
			img: GuideStepTwo,
			label: 'Step 2',
			description: 'Go to Security and privacy',
		},
		{
			img: GuideStepThree,
			label: 'Step 3',
			description: 'Turn off the Block opening external apps option',
		},
	];

	useEffect(() => {
		if (open && swiperRef.current) {
			swiperRef.current.slideTo(activeIndex);
		}
	}, [open, activeIndex]);

	const handleButtonClick = (idx: number) => {
		swiperRef.current?.slideTo(idx); // 슬라이드 이동
		setActiveIndex(idx);
	};

	if (!open) return null;

	return (
		<div className="fixed inset-0 z-[9999] bg-black/50 backdrop-blur-sm flex items-center justify-center pointer-events-auto">
			<div className="relative w-[280px] rounded-lg bg-white overflow-hidden">
				{/* 상단 이미지/슬라이드 */}
				<div className="w-full h-[356px] relative">
					<Swiper
						onSwiper={swiper => {
							swiperRef.current = swiper;
						}}
						onSlideChange={swiper => setActiveIndex(swiper.activeIndex)}
						slidesPerView={1}>
						{GuideSteps.map((step, idx) => (
							<SwiperSlide key={`step-${idx}`}>
								<div className="w-[280px] h-[356px] bg-[#FFD400] flex items-center justify-center">
									<img
										src={step.img}
										alt={`step${idx + 1}`}
										className="object-contain w-full h-full"
									/>
								</div>
							</SwiperSlide>
						))}
					</Swiper>

					{/* 닫기 버튼 */}
					<button
						onClick={() => {
							onCancel?.();
							onOpenChange(false);
						}}
						className="absolute z-10 w-6 h-6 top-2 right-2">
						<img src={CloseIcon} alt="close" />
					</button>
				</div>

				{/* STEP 버튼들 */}
				<div className="flex justify-center gap-2 mt-4">
					{GuideSteps.map((step, idx) => {
						return activeIndex === idx ? (
							<img
								key={step.description}
								src={ActiveCircleIcon}
								alt="active button cursor-pointer"
							/>
						) : (
							<span
								key={step.label}
								onClick={() => handleButtonClick(idx)}
								className="inline-block w-2 h-2 rounded-full cursor-pointer bg-gray-05"
							/>
						);
					})}
				</div>

				{/* 하단 설명 */}
				<div className="flex flex-col gap-1 px-4 mt-4 mb-6">
					<p className="font-medium">{GuideSteps[activeIndex].label}</p>
					<p className="h-10 font-normal leading-5">
						{GuideSteps[activeIndex].description}{' '}
					</p>
				</div>
			</div>
		</div>
	);
}
